<template>
    <div>
        
        <b-container>
            <b-row>
                <b-col>
                    <h4>Your Inventory</h4>
                </b-col>
            </b-row>
            <!-- Add a brewery -->
            <b-row>
                <b-col>
                <div style="margin-top:10px; margin-bottom:10px">
                    <b-button v-b-modal.addBrewerModal block  variant="primary">
                        <h4>ADD A BREWERY</h4>
                    </b-button>
                </div>
                </b-col>
            </b-row>

            <!-- Add brewery modal -->
            <b-row>
                <b-col>
                    <b-modal  size="xl" id="addBrewerModal" title="Add A Brewer"  ok-only ok-title ='Cancel'>
                        <b-container class='inventorycard' style="margin-top:10px; margin-bottom:20px">
                            <b-row>
                                <b-col>
                                    <form>
                                        <div style="margin-top:10px">
                                            <label for="brewerName" size="sm">Brewery Name</label>
                                            <div v-if='invalidName' class='inputwarning'>Please check brewery name</div>
                                            <input v-model="brewer.company" type="text" placeholder="Awesome Brewery" id="brewerName" />
                                        </div>
                                    </form>

                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col>
                                    <form>
                                        <label for="description">Description</label>
                                        <textarea v-model.trim="brewer.description" id="description" placeholder="Description"> </textarea>
                                    </form>

                                </b-col>
                        </b-row>


                            <b-row>
                                <b-col>
                                    <div style="margin-top:20px; margin-bottom:20px">
                                        <div v-if="showAddBrewerError" class='inputwarning'> Please correct the errors above</div>
                                        <b-button  size="lg" @click="addBrewer()" class="btn btn-success">Add This Brewer</b-button>
                                        <transition name="fade">
                                        <p v-if="showSuccess" class="success">Brewer added</p>
                                        </transition>
                                    </div>
                                </b-col>

                            </b-row>

                        </b-container>
                    </b-modal>
                </b-col>
            </b-row>

            <!-- Breweries collapse button -->
            <b-row>
                <b-col>
                    <div class="input-group" style='margin-top:10px; margin-bottom:10px'>
                            <b-button squared v-b-toggle.collapse-breweries class="btn btn-secondary" type="button">Breweries</b-button>
                            <div class="input-group-append">
                            <b-button v-b-toggle.collapse-breweries class="btn btn-secondary" type="button"> 
                                <font-awesome-icon icon="caret-down" />
                            </b-button>
                            </div>
                    </div>
                </b-col>
            </b-row>
            <!-- Breweries collapse -->
            <b-collapse visible id="collapse-breweries">
                <b-row>
                    <b-card v-for="(brewery) in distributorBreweries" :key="brewery.company"
                        border-variant="secondary"
                        tag="article"
                        style="width: 300px; margin:10px; "
                        class="mb-2" header-bg-variant="info" header-text-variant="white"
                        >
                        <template #header>
                            <h6 class="mb-0" style="text-align:center">{{brewery.company}}</h6>
                        </template>
                            <b-container fluid>
                                <!-- Logo -->
                                <b-row>
                                    <b-col>
                                        <input id="fileUpload"  @change="onLogoFileChanged"  type="file" hidden>
                                        <div style="height:110px; text-align: center;  margin-bottom:10px">
                                            <img v-if="brewery.logoFileThumbnailURL" @click="chooseFiles($event, brewery.uid)" style="cursor: pointer;" height="100px" :src="brewery.logoFileThumbnailURL"/>
                                            <img v-else @click="chooseFiles($event, brewery.uid)" style="cursor: pointer;" height="100px" src="../assets/addalogo.png"/>
                                        </div>
                                    </b-col>
                                </b-row>

                                <!-- Manage Brewery button -->
                                
                                <b-row>
                                    <b-col style="text-align:center">
                                        <b-button @click="manageBrewery(brewery)">Manage</b-button>
                                    </b-col>
                                </b-row>
                                

                            </b-container>
                        </b-card>
                </b-row>
             </b-collapse>


        <!--       INVENTORY     -->

        <!-- Add a beverage -->
        <b-row>
            <b-col style="margin-top:20px">
                <b-button size="lg" block class="m-md-2" variant="info" @click="$router.push('selecttype')">
                    Add a Beverage
                </b-button>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-modal  size="xl" id="addBeerModal" title="Add A Beer"  ok-only ok-title ='Cancel'>
                    <addinventorycomponent />
                </b-modal>
            </b-col>
        </b-row>

        <!-- End Add Inventory -->
        <template v-for="(item) in distributorBeers"> 
            <b-row :key="item.id">
                <b-col>
                    <Beerinventorycomponent :theOrigBeer="item" />
                </b-col>
            </b-row>
        </template>


        </b-container>
        <footer><pagefooter/></footer>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { currentUser } from '../firebaseConfig'
    import moment from 'moment'
    const fb = require('../firebaseConfig.js')
    import firebase from 'firebase/app';
    import axios from 'axios'
    import Addinventorycomponent from './Addinventorycomponent'
    import Beerinventorycomponent from './Beerinventorycomponent'
    import Pagefooter from './Pagefooter'
    export default {
            components: {
            Pagefooter,
            Addinventorycomponent,
            Beerinventorycomponent,
        },

        computed: {
            ...mapState(['userProfile', 'currentUser', 'promotionsEnabled', 'distributorBreweries', 'distributorBeers']),
        },

        data() {
            return {
                brewer:{
                    company:'',
                    description:'',
                    logoFileThumbnailURL:'',
                    },
                    invalidName:false,
                    showAddBrewerError:false,
                    showSuccess: false,
                    fileName:'',
                    fileExtension:'',
                    cloudinary: {
                        uploadPreset: 'vuelicenseupload',
                        thumbnailPreset: 'uploadthumbnail',
                        logoFullPreset:'logofullpreset',
                        logoThumbPreset:'logothumbpreset',
                        apiKey: '629997215451183',
                        cloudName: 'lo4xxr5lr',
                        uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/upload'
                    }, 
                    breweryIdForLogo:'',
                    selectedFile:'',
                    addingLicense:false,


            }
        },
        methods: {
            addBrewer() {

                if(!this.brewer.company){
                    this.invalidName = true
                } 
                else this.invalidName = false

                if(this.invalidName) this.showAddBrewerError = true
                
                //Return if any of the fields have an error
                if(this.showAddBrewerError) return

                this.$root.$emit('bv::hide::modal',"addBrewerModal")

                console.log("Adding ")
                console.log(this.brewer)
                /*fb.usersCollection.doc(this.currentUser.uid).update({
                        breweries: firebase.firestore.FieldValue.arrayUnion({brewery: this.brewer, logoFileThumbnailURL:''})
                        }).then((response) => {
                            this.showSuccess = true
                            setTimeout(() => { this.showSuccess = false }, 1500)
                                })*/


                    /********************** */
                var createdDate = new Date()
                var createdTime = createdDate.getTime()

                var min=11111111111111111; 
                var max=99999999999999999; 

                var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
                var randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                fb.distributorBrewersCollection.add({
                    createdOn: createdDate,
                    createdTime: createdTime,
                    company: this.brewer.company,
                    distributorId:this.currentUser.uid,
                    id: randomIdString,
                    distbrewerid:randomIdString,
                    description: this.brewer.description,
                    logoFileThumbnailURL:'',
                    counties:this.userProfile.counties,

                }).then(() => {
                        this.showSuccess = true
                        this.$bvToast.toast(this.brewer.company+ 'Added', {
                        title: 'Brewery Added!',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })

                        setTimeout(() => { this.showSuccess = false }, 2000)
                        this.brewer.company = ''
                        this.brewer.description = ''

                })


                    /********************** */
            },
            chooseFiles(event, breweryId) {
                console.log("Brewery ID = " + breweryId)
                this.breweryIdForLogo = breweryId
                document.getElementById("fileUpload").click()
            
            },
            onLogoFileChanged (event) {
                console.log("File changed")
                this.selectedFile = event.target.files[0]
                const name = event.target.files[0].name;
                const lastDot = name.lastIndexOf('.');

                this.fileName = name.substring(0, lastDot);
                this.fileExtension = name.substring(lastDot + 1);

                console.log(this.fileName, this.fileExtension)
                this.uploadLogotoCloudinary()
            },
            
            uploadLogotoCloudinary(){
                this.addingLicense = true
                let data = new FormData();
                data.append('file', this.selectedFile); 
                data.append('upload_preset', this.cloudinary.logoThumbPreset);

                axios
                    .post(this.cloudinary.uploadURL, data)
                    .then((result) => {
                        if(result.data.secure_url){
                            fb.distributorBrewersCollection.doc(this.breweryIdForLogo).update({
                            logoUploaded:1,
                            logoFileURL:result.data.secure_url
                            })
                        }
                        this.addingLicense = false

                    })
                    .catch((err) => {
                        console.log('Ax Error:' + err);
                        this.addingLicense = false
                    }) 

                let thumbdata = new FormData();
                thumbdata.append('file', this.selectedFile); 
                thumbdata.append('upload_preset', this.cloudinary.logoThumbPreset);

                //Add thumbnail
                axios
                    .post(this.cloudinary.uploadURL, thumbdata)
                    .then((result) => {
                        if(result.data.secure_url){
                            fb.distributorBrewersCollection.doc(this.breweryIdForLogo).update({
                            licenseUploaded:1,
                            logoFileThumbnailURL:result.data.secure_url
                        })
                        }
                        this.addingLicense = false
                    })
                    .catch((err) => {
                        console.log('Ax Thumb Error:' + err);
                        this.addingLicense = false
                    })

            },

            //Go to manage brewery page 
            manageBrewery(brewer){
                console.log("distbrewerid=" + brewer.distbrewerid)
                this.$store.commit('setSelectedDistBrewery', brewer)
                this.$router.push({ path: 'managebrewery', query: {distbrewerid:brewer.distbrewerid }})
            },

        },
        
    }
</script>